<template>
  <div class="warp">
    <img src="../assets/daylocation/banner.png" alt="" />
    <div class="box-warp">
      <div class="box" v-for="(item, index) in list" :key="index">
        <div class="box-title">{{ item.title }}</div>
        <div class="box-sub-title">{{ item.subtitle }}</div>
        <img :src="item.img" class="img" />
      </div>
    </div>
    <div class="web-site-warp">
      <img src="../assets/logo2.png" class="logo" v-if="apkId == 0" />
      <img src="../assets/logo.png" class="logo" v-else />

      <div class="web-site-title-warp">
        <div class="web-site-title">
          {{ apkId == 0 ? "短信定位" : "天天定位" }}
        </div>
        <div class="web-site-sub-title">随时随地定位TA，守护亲友安全</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "dayLocation",
  data() {
    return {
      apkId: null,
      list: [
        {
          title: "第一步：打开好友分享的连接",
          subtitle: "点击好友分享的连接",
          img: require("../assets/daylocation/banner-1.png"),
        },
        {
          title: "第二步：打开位置权限",
          subtitle: "在设置中，打开位置权限",
          img: require("../assets/daylocation/banner-2.png"),
        },
        {
          title: "第三步：共享位置信息",
          subtitle: "打开位置权限后即可共享位置信息",
          img: require("../assets/daylocation/banner-3.png"),
        },
      ],
    };
  },

  methods: {
    getUserLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            // this.latitude = position.coords.latitude;
            // this.longitude = position.coords.longitude;
            this.position_fun(position);
            this.testposition_fun(position);
          },
          (error) => {
            console.error("Error getting user location:", error);
          }
        );
      } else {
        console.error("Geolocation is not supported by this browser.");
      }
    },
    getUrlParams() {
      const url = new URL(window.location.href);
      const params = new URLSearchParams(url.search);
      return Object.fromEntries(params.entries());
    },
    position_fun(position) {
      let params = {
        lat: Math.round(position.coords.latitude * 10000) / 10000,
        lng: Math.round(position.coords.longitude * 10000) / 10000,
        timeZoneOffset: new Date().getTimezoneOffset() / 60,
      };
      const urlParams = this.getUrlParams();
      if (urlParams.key) {
        axios
          .post("//lwapi.wnshouhu.com/v1/locationInfo/pushLastAddress", {
            key: urlParams.key.replace(/\s+/g, "+") || "",
            ...params,
          })
          .then((res) => {
            console.log(res);
          });
      }
    },
    testposition_fun(position) {
      let params = {
        lat: Math.round(position.coords.latitude * 10000) / 10000,
        lng: Math.round(position.coords.longitude * 10000) / 10000,
        timeZoneOffset: new Date().getTimezoneOffset() / 60,
      };
      const urlParams = this.getUrlParams();
      if (urlParams.key) {
        axios
          .post("//lwtestapi.wnshouhu.com/v1/locationInfo/pushLastAddress", {
            key: urlParams.key.replace(/\s+/g, "+") || "",
            ...params,
          })
          .then((res) => {
            console.log(res);
          });
      }
    },
  },
  mounted() {
    this.getUserLocation();
    function getQueryString(name) {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      const search = decodeURIComponent(window.location.search.substr(1));
      const r = search.match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    }
    this.apkId = getQueryString("apkId");
    console.log(this.$route);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
img {
  width: 100%;
  object-fit: cover;
}
.box {
  margin: 0 30px;
  padding-top: 22px;
}
.box-sub-title {
  color: #333333;
  font-size: 14px;
  margin-top: 12px;
  margin-bottom: 15px;
}
.box-title {
  font-size: 19px;
  font-weight: 600;
  color: #111111;
  line-height: 26px;
  position: relative;
  display: inline-block;
}
.box-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  display: block;
  height: 12px;
  background: #ffdd00;
  opacity: 0.39;
  width: 100%;
}
.box-warp {
  margin-top: -145px;
  border-radius: 24px 24px 0px 0px;
  background: #fff;
  z-index: 100;
  position: relative;
}
.web-site-warp {
  padding-top: 45px;
  padding-bottom: 22px;
  display: flex;
  justify-content: center;
  align-content: center;
}
.logo {
  width: 33px;
  height: 33px;
  margin-right: 7px;
}
.web-site-title {
  font-size: 14px;
  color: #111111;
  line-height: 20px;
  font-weight: bold;
}
.web-site-sub-title {
  font-size: 8px;
  font-weight: 400;
  color: #666666;
  transform: scale(0.7);
  transform-origin: 0 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dayLocation.vue